export default __webpack_public_path__ + "static/media/person_3.a087dba4.png";